import { I18n } from '@calendly/i18n'
import { BodyText } from '@calendly/ui/components/typography'

import { HostsSearch } from '../inputs/hosts_search'
import { OwnersSearch } from '../inputs/owners_search'
import { PermissionSelector } from '../inputs/permission_selector'

export const SingleUserScope = ({
  selectedHostIds, setSelectedHostIds,
  selectedOwnerIds, setSelectedOwnerIds,
  selectedPermission, setSelectedPermission
}) => (
  <>
    <BodyText>
      {I18n.t('publisher.event_types.filters.description.personal')}
    </BodyText>

    <HostsSearch selectedIds={selectedHostIds} setSelectedIds={setSelectedHostIds} />
    <OwnersSearch selectedIds={selectedOwnerIds} setSelectedIds={setSelectedOwnerIds} />
    <PermissionSelector
      value={selectedPermission}
      onChange={setSelectedPermission}
    />
  </>
)
